// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Dfxs","productName":"Table_productName__3PfNX"};